export enum Colors {
    primary = 'primary',
    secondary = 'secondary',
    purple = 'purple',
}

export type Color = `${Colors}`;

export enum Variants {
    default = 'default',
    small = 'small',
    mini = 'mini',
    round = 'round',
}

export type Variant = `${Variants}`;
